import * as React from 'react';
import { useState } from 'react'; // Explicitly import useState
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import AppTheme from '../shared-theme/AppTheme';
import ColorModeSelect from '../shared-theme/ColorModeSelect';
import SignInCard from '../components/SignInCard';
import Content from '../components/Content';
import { signIn } from '../api/auth'; // Import signIn from auth.js
import Copyright from '../internals/components/Copyright'

export default function SignInSide({ onLoginSuccess, ...props }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSignIn = async () => {
    try {
      const { user } = await signIn(email, password);
      setError(''); // Clear any previous errors
      if (onLoginSuccess) {
        onLoginSuccess(user); // Call the callback with the authenticated user
        window.location.href = '/'; // Redirect to the home page
      }
    } catch (err) {
      setError(err.message); // Display login error
    }
  };

  return (
    <AppTheme {...props}>
      <CssBaseline enableColorScheme />
      <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} />
      <Stack
        direction="column"
        component="main"
        sx={[
          {
            width: '100%',
            justifyContent: 'center',
            height: 'calc((1 - var(--template-frame-height, 0)) * 100%)',
            marginTop: 'max(80px - var(--template-frame-height, 0px), 0px)',
            minHeight: '100%',
          },
          (theme) => ({
            '&::before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              zIndex: -1,
              inset: 0,
              backgroundImage:
                'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
              backgroundRepeat: 'no-repeat',
              ...theme.applyStyles('dark', {
                backgroundImage:
                  'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
              }),
            },
          }),
        ]}
      >
        <Stack
          direction='column'
          sx={{
            justifyContent: 'center',
            gap: 6,
            p: 2,
            mx: 'auto',
          }}
        >
            <SignInCard
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              error={error}
              onSignIn={handleSignIn}
            />
            <Copyright></Copyright>
        </Stack>
      </Stack>
    </AppTheme>
  );
}